export const isWinterCoverletPromoEnabled = () =>
  process.env.REACT_APP_ENABLE_WINTER_COVERLETS_PROMO === "true";
export const isBlackFridayPromoEnabled = () =>
  process.env.REACT_APP_ENABLE_BLACK_FRIDAY_PROMO === "true";
export const isCloudPillowGWPEnabled = () =>
  process.env.REACT_APP_ENABLE_CLOUD_PILLOW_GWP === "true";
export const isRestMiniGWPEnabled = () =>
  process.env.REACT_APP_ENABLE_REST_MINI_GWP === "true";
export const isAutoApplyDiscountCodeEnabled = () =>
  process.env.REACT_APP_ENABLE_AUTO_APPLY_DISCOUNT_CODE === "true";
export const getAutoApplyDiscountCode = () =>
  process.env.REACT_APP_AUTO_APPLY_DISCOUNT_CODE;
